<template>
  <div v-if="loggedIn" class="goc-activity-container">
    <p class="main-title">
      Please select the gift collection you purchased. Your activity will populate below! You'll also be able to manage your entire campaign, search users,  resend notification emails, and have access to redemption links.
    </p>
    <div class="collection-selection-container">
        <p class="title">Please select a collection:</p>
        <select v-if="collections.length > 0 || emails.length > 0"  v-model="selectedGOC"  class="variant-selector">
            <option v-for="collection in collections" :key="collection.handle" :value="collection.handle">{{collection.name}}</option>
            <option v-if="emails.length > 0" value="emailSends">Gift Boxes Sent with an Email</option>
        </select>
    </div>
    <div v-if="selectedGOC" class="collection-report-container">
        <div class="charts-container">
            <div class="claimed-chart">
                <apexchart type="donut" :options="reclaimedChartOptions" :series="reclaimedChartData"></apexchart>
            </div>
            <div class="unclaimed-chart">
                <apexchart type="donut" :options="unclaimedChartOptions" :series="unclaimedChartData"></apexchart>
            </div>
        </div>
        <div class="email-container">
          <div class="email-actions-container">
            <div class="actions-container">
              <button class="happybox-button yellow" @click="openResendAlert(itemsSelected)" :disabled="canBulkResend == false"><img src="https://cdn.shopify.com/s/files/1/0600/4401/7839/files/email.svg?v=1698159625"/> Resend reminder series</button>
              <button class="happybox-button purple" @click="openCancelAlert(itemsSelected)" :disabled="canBulkCancel == false"><span>X</span> Cancel selected</button>
            </div>
          </div>
            <vue-good-table
            :columns="tableHeaders"
            :rows="tableData"
            styleClass="vgt-table striped bordered condensed"
            :search-options="{
              enabled: true
            }"
            :sort-options="{
              enabled: true,
            }"
            :pagination-options="{
              enabled: true,
              mode: 'pages',
              perPage: 50,
              dropdownAllowAll: false,
            }"
            :select-options="{
              enabled: true,
              selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
              selectionInfoClass: 'custom-class',
              selectionText: 'rows selected',
              clearSelectionText: 'clear',
            }"
            @on-selected-rows-change="tbSelectionChanged"
          >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'actions'">
              <div class="actions-icons">
                <p v-tooltip="{content: 'Cancel Order',container: false }" v-if="props.row.status != 'Claimed' && props.row.status != 'Cancelled'" @click="openCancelAlert([props.row])" src="https://cdn.shopify.com/s/files/1/0600/4401/7839/files/trash_05a3e1b5-b394-4f91-aaf3-599964c057cb.svg?v=1698249866">X</p>
                <img v-tooltip="{content: 'Resend reminder',container: false }" v-if="props.row.status != 'Claimed' && props.row.status != 'Scheduled' && props.row.status != 'Cancelled'" @click="openResendAlert([props.row])" src="https://cdn.shopify.com/s/files/1/0600/4401/7839/files/email.svg?v=1698159625"/>
              </div>
            </span>
            <span v-else-if="props.column.field == 'link'">
              <p class="clickable" @click="copyLink(props.row.href)">{{props.row.link}}</p>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
          <div class="table-footer" slot="table-actions-bottom">
            <button @click="downloadXlsx(itemsSelected)" class="hb-btn primary" :disabled="itemsSelected.length == 0">Export Selected</button>
          </div>
          </vue-good-table>
        </div>
    </div>
    <div class="spinner-container" v-if="isLoading">
      <div class="spinner"></div>
    </div>
  </div>
  <div v-else class="loading-container">
      <div class="spinner"></div>
    </div>
</template>

<script>
import axios from "axios";
import * as XLSX from 'xlsx/xlsx.mjs';
import { VueGoodTable } from 'vue-good-table';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'vue-good-table/dist/vue-good-table.css'
export default {
  data(){
      return {
        loggedIn: false,
        selectedGOC: null,
        isLoading: false,
        email: null,
        gocs: [],
        emails: [],
        openEditModal: false,
        selectedEditOrder: null,
        tableHeaders: [
          {label:"Order Number",field:"order"}
          ,{label:"Recipient Name",field:"recipientName", sortable: true}
          ,{label:"Recipient Email",field:"recipientEmail", sortable: true}
          ,{label:"Status",field:"status"}
          ,{label:"Notification Date",field:"sentAt", sortable: true}
          ,{label:"From",field:"sentBy"}
          ,{label:"Gift Selected",field:"gift"}
          ,{label:"Link",field:"link"}
          ,{label:"Actions",field:"actions", width: 80}
        ],
        itemsSelected: [],
        searchValue: "",
        searchFields: ["recipientName","recipientEmail"],
        sortBy: "recipientName",
        sortType: "asc",
        showStatusFilter: false,
        statusFilter: "All",
        url: "https://portal.happyboxstore.com:5054/",
        GOCCollections: []
      }
  },
  components: {
    VueGoodTable
  },
  watch:{
    collections(){
      if(this.collections.length > 0){
        this.selectedGOC = this.collections[0].handle;
      }
    }
  },
  computed:{
    collections(){
      if(this.GOCCollections.length > 0 && this.gocs.length > 0){
        let data = this.gocs.filter(x => x.collectionHandle).map(x => x.collectionHandle);
        let uniqNames = [...new Set(data)];
        return this.GOCCollections.filter(x => uniqNames.includes(x.handle));
      }
      return [];
    },
    tableData(){
      if(this.selectedGOC){
          // Check if we should pull from emails instead of gocs
          let data = this.selectedGOC === 'emailSends' 
            ? this.emails 
            : this.gocs.filter(x => x.collectionHandle == this.selectedGOC);
          
          return data.map((x) => {
              let status = x.reclaimed ? "Claimed" : ( x.cancelled ? "Cancelled" : (x.notificationSent ? "Sent" : "Scheduled"));
              if(!x.cancelled && !x.reclaimed){
                  let nowStamp = new Date().getTime();
                  let futurestamp = new Date(x.notificationDate).getTime() + (30 * 24 * 60 * 60 * 1000);
                  if(futurestamp < nowStamp){
                      status = "Expired";
                  }
                  if(x.expired){
                      status = "Expired";
                  }
              }
              let link = "";
              if(this.selectedGOC === 'emailSends' && x.token){
                link = `https://happyboxstore.com/products/redeem-gift?emailGift=${x.token}`;
              }
              else if(x.token){
                link = `https://happyboxstore.com/products/redeem?gift=${x.token}`;
              }
              let shortenedLink = this.pathShorten(link);
              let gifts = "";
              if(this.selectedGOC === 'emailSends' && x.orderInformation && x.orderInformation.title){
                gifts = `${x.orderInformation.quantity}x ${x.orderInformation.title}`;
              }
              else if(x && x.productList && x.productList.length > 0){
                let products = x.productList.map((y) => {
                    return `${y.qty}x ${y.name}`;
                })
                gifts = products.join(", ");
              }
              return {
                  "giftId": x.giftId
                  ,"order": x.orderName
                  ,"recipientName": `${this.capitalizeFirstLetter(x.recipientFirstName)} ${this.capitalizeFirstLetter(x.recipientLastName)}`
                  ,"recipientEmail": x.recipientEmail
                  ,"status": status
                  ,"sentAt": new Date(x.notificationDate).toLocaleDateString("en-US").replaceAll("/","-")
                  ,"sentBy": x.from
                  ,"gift": gifts
                  ,"link": shortenedLink
                  ,"href": link
              }
          })
      }


      return [];
    },
    canBulkResend(){
      return this.itemsSelected.length > 0 && this.itemsSelected.every(x => x.status != "Claimed" && x.status != "Scheduled"  && x.status != 'Cancelled');
    },
    canBulkCancel(){
      return this.itemsSelected.length > 0 && this.itemsSelected.every(x => x.status != "Claimed" && x.status != 'Cancelled');
    },
    reclaimedChartOptions(){
      if(this.selectedGOC){
          return {
              chart: {
                  type: 'donut',
                  foreColor: '#0f0c38'
              },
              colors: ["#00e396","#feb019","#008ffb","#9f45ff"],
              labels:["Claimed","Unclaimed","Scheduled"],
              title: {
                  text: "Total Gifts",
                  style:{
                      fontFamily: 'Karla',
                      color:  '#0f0c38'
                  }
              },
              dataLabels: {
                  enabled: false
              },
              legend:{
                  fontFamily: 'Karla',
                  formatter: function(seriesName, opts) {
                      return [seriesName, " - ", opts.w.globals.series[opts.seriesIndex], " - ",  `${Math.round((opts.w.globals.seriesPercent[opts.seriesIndex][0] + Number.EPSILON) * 100) / 100}%`]
                  }
              },
              plotOptions: {
                  pie: {
                      donut: {
                          labels: {
                              show: true,
                              total:{
                                  show: true,
                                  label: 'Total',
                              }
                          }
                      }
                  }
              }
          }
      }
      return {}
    },
    reclaimedChartData(){
        if(this.selectedGOC){
            // Check if we should pull from emails instead of gocs
            let data = this.selectedGOC === 'emailSends' 
              ? this.emails 
              : this.gocs.filter(x => x.collectionHandle == this.selectedGOC);
            
            let claimed = data.filter(x => x.reclaimed);
            let notClaimed = data.filter(x => !x.reclaimed);
            let scheduled = notClaimed.filter(x => !x.notificationSent && !x.cancelled);
            return [claimed.length, notClaimed.length - scheduled.length,scheduled.length]
        }

        return {};
    },
    unclaimedChartOptions(){
      if(this.selectedGOC){
        return {
            chart: {
                type: 'donut',
                foreColor: '#0f0c38'
            },
            colors: ["#008ffb","#E4E4E4","#FFB2B2","#e0e7ff"],
            labels:["Scheduled","Cancelled","Expired","Sent"],
            fill: {
                colors: ["#008ffb","#E4E4E4","#FFB2B2","#e0e7ff"],
            },
            title: {
                text: "Unclaimed Gifts",
                style:{
                    fontFamily: 'Karla',
                    color:  '#0f0c38'
                }
            },
            dataLabels: {
                enabled: false
            },
            legend:{
                fontFamily: 'Karla',
                formatter: function(seriesName, opts) {
                    return [seriesName, " - ", opts.w.globals.series[opts.seriesIndex], " - ",  `${Math.round((opts.w.globals.seriesPercent[opts.seriesIndex][0] + Number.EPSILON) * 100) / 100}%`]
                }
            },
            plotOptions: {
                pie: {
                    donut: {
                        labels: {
                            show: true,
                            total:{
                                show: true,
                                label: 'Total',
                            }
                        }
                    }
                }
            }
        }
      }

      return {}
    },
    unclaimedChartData(){
      if(this.selectedGOC){
          // Check if we should pull from emails instead of gocs
          let data = this.selectedGOC === 'emailSends' 
            ? this.emails 
            : this.gocs.filter(x => x.collectionHandle == this.selectedGOC);
          
          let notClaimed = data.filter(x => !x.reclaimed);
          let notSent = notClaimed.filter(x => !x.notificationSent && !x.cancelled);
          let cancelled = notClaimed.filter(x => x.cancelled);
          let expired = notClaimed.filter((x) => {
              if(x.cancelled)
                  return false
              let nowStamp = new Date().getTime();
              let futurestamp = new Date(x.notificationDate).getTime() + (30 * 24 * 60 * 60 * 1000);
              if(futurestamp < nowStamp || x.expired){
                  return true
              }

              return false
          })
          let notReclaimed = notClaimed.filter((x) => {
              if(x.cancelled)
                  return false
              if(!x.notificationSent)
                  return false
              let nowStamp = new Date().getTime();
              let futurestamp = new Date(x.notificationDate).getTime() + (30 * 24 * 60 * 60 * 1000);
              if(futurestamp < nowStamp || x.expired){
                return false
              }

              return true
          })
          return [notSent.length, cancelled.length, expired.length,notReclaimed.length]
      }

      return {};
    },
  },
  methods:{
      async login(){
        axios.get(`/apps/loggedincustomer`).then((res) => {
          if(res.data && res.data.email){
            this.email = res.data.email;
            this.getGiftActivity(res.data);
          }
        })
      },
      async getGiftActivity(user){
        axios.get(`${this.url}hb/activity/${user.email}`).then((res) => {
          if(res.data){
            this.gocs = res.data.gocs;
            this.emails = res.data.emailSends;
            this.loggedIn = true;
          }
        })
      },
      pathShorten(u) {
        let uend = u.slice(u.length - 15);
        let ustart = u.replace('http://', '').replace('https://', '').substr(0, 32);
        var shorter = ustart + '...' + uend;
        return shorter;
      },
      copyLink(url){
        navigator.clipboard.writeText(url).then(function() {
            alert("link copied")
        }, function() {
            console.log('Copy error')
        });
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      tbSelectionChanged(event){
        this.itemsSelected = event.selectedRows;
      },
      getGOCCollections(){
        axios.get(`https://happyboxstore.com/collections/gift-collections/products.json`)
        .then(response => response.data)
        .then((data) => {
          this.GOCCollections = data.products.map((x) => {
            return {name: x.title, handle: x.handle}
          });
        })
      },
      downloadXlsx(itemsSelected){
        // export json to Worksheet of Excel
        // only array possible

        let objectData = itemsSelected.map((x) => {
          return {
            "Recipient Name": x.recipientName
            ,"Recipient Email": x.recipientEmail
            ,"From": x.sentBy
            ,"Notification Date": x.sentBy
            ,"Status": x.status
            ,"Redemption Link": x.href
          }
        })

        var data = XLSX.utils.json_to_sheet(objectData) 

        // A workbook is the name given to an Excel file
        var wb = XLSX.utils.book_new() // make Workbook of Excel

        // add Worksheet to Workbook
        // Workbook contains one or more worksheets
        XLSX.utils.book_append_sheet(wb, data, 'Gift Instantly') // sheetAName is name of Worksheet
        // export Excel file
        XLSX.writeFile(wb, 'Gift Instantly.xlsx');
      },
      openResendAlert(emails){
        if(!this.canBulkResend && emails.length > 1){
          this.impossibleActionPopUp(false);
        }
        else
        Swal.fire({
          title: `Would you like to resend ${emails.length} ${emails.length > 1 ? 'emails' : 'email'}`,
          showCancelButton: true,
          confirmButtonText: 'Yes, Resend Orders',
          cancelButtonText: 'Cancel',
          customClass:{
              container:"swal-custom-container",
              popup: "swal-custom-popup-2",
              title:"swal-title",
              confirmButton: "hb-btn primary",
              cancelButton: "hb-btn secondary"
          },
          }).then((result) => {
          if (result.isConfirmed) {
              this.isLoading = true;
              this.resend(emails);
          }
        })
    },
    openCancelAlert(emails){
      if(!this.canBulkCancel && emails.length > 1){
        this.impossibleActionPopUp(true);
      }
      else
      Swal.fire({
        title: `Are you sure you want to cancel ${emails.length} ${emails.length > 1 ? 'orders' : 'order'}`,
        showCancelButton: true,
        confirmButtonText: 'Cancel Order',
        cancelButtonText: 'No',
        customClass:{
            container:"swal-custom-container",
            popup: "swal-custom-popup-3",
            title:"swal-title",
            confirmButton: "hb-btn primary",
            cancelButton: "hb-btn secondary"
        },
        }).then((result) => {
        if (result.isConfirmed) {
            this.isLoading = true;
            this.cancel(emails);
        }
      })
    },
    impossibleActionPopUp(cancel){
      Swal.fire({
        title: `Can't ${cancel ? 'cancel' : 'resend'} claimed gifts`,
        showCancelButton: false,
        confirmButtonText: 'Understood',
        customClass:{
            container:"swal-custom-container",
            popup: "swal-custom-popup-2",
            title:"swal-title",
            confirmButton: "hb-btn primary",
            cancelButton: "hb-btn secondary"
        },
        }).then((result) => {
      })
    },
    async resend(emails){
      let gifts = [];
      if(this.selectedGOC === 'emailSends'){
        gifts = await axios.put(`${this.url}hb/email/resend/${this.email}`, {orders: emails},
      {
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: 50000
      });
      }
      else{
        gifts = await axios.put(`${this.url}hb/goc/resend/${this.email}`, {orders: emails},
      {
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: 50000
      });
      }
      if(gifts && gifts.data){
        this.gocs = gifts.data.gocs;
        this.emails = gifts.data.emailSends;
      }
      this.isLoading = false;
      alert("Orders will take up to 5 minutes to update.");
    },
    async cancel(emails){
      let gifts = [];
      if(this.selectedGOC === 'emailSends'){
        gifts = await axios.put(`${this.url}hb/email/cancel/${this.email}`, {orders: emails},
      {
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: 50000
      });
      }
      else{
        gifts = await axios.put(`${this.url}hb/goc/cancel/${this.email}`, {orders: emails},
        {
          headers: {
            'Content-Type': 'application/json',
          },
          timeout: 50000
        });
      }
      
      if(gifts && gifts.data){
        this.gocs = gifts.data.gocs;
        this.emails = gifts.data.emailSends;
      }
      this.isLoading = false;
    }
  },
  mounted(){
    this.getGOCCollections();
    this.login();
  },
}
</script>

<style>

    .goc-activity-container p,.goc-activity-container span{
      color: #0F0C38;
      margin: 0;
    }

    .loading-container{
    width: 100%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .loading-container p{
    font-size: 1.15vw;
    color: #0f0c38;
    font-family: "Karla";
    margin-bottom: 2%;
    text-align: center;
  }

  .spinner-container{
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.1);
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .spinner-container.top{
    align-items: flex-start;
    padding-top: 5%;
  }

  .spinner {
    border: 4px solid rgba(0, 0, 0, 0.3);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border-left-color: #09f;
    animation: spin 1s ease infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  .collection-selection-container{
    width: 100%;
    border-bottom: 1px solid black;
    display: flex;
    grid-gap: 5px;
    gap: 5px;
    padding-bottom: 3%;
    margin: 3% 0;
    align-items: center;
  }

  .collection-selection-container .variant-selector{
    border: 1px solid black;
    border-radius: 4px;
    height: unset;
  }

  .collection-selection-container .title{
    font-size: 1.15vw;
    white-space: nowrap;
  }

  .charts-container{
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .claimed-chart, .unclaimed-chart{
    width: 49%;
    border: 0.5px solid black;
    border-radius: 30px;
    padding: 1%;
    margin-bottom: 2%;
  }

  .actions-icons{
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .actions-icons img{
    width: 15px;
    height: auto;
    cursor: pointer;
  }

  .actions-icons p{
    cursor: pointer;
    font-size: 15px;
  }

  .clickable{
    cursor: pointer;
  }

  .table-footer{
    display: flex;
    justify-content: flex-end;
    padding: 0% 2%;
  }

  .table-footer button{
    padding: 1% 10%;
    margin: 2% 0;
    font-size: 11px;
  }

  table.vgt-table
  ,.vgt-wrap__footer
  ,.vgt-wrap__footer .footer__row-count__label
  ,.vgt-wrap__footer .footer__row-count__select
  ,.vgt-wrap__footer .footer__navigation
  ,.vgt-wrap__footer .footer__navigation__page-btn span{
    font-size: 11px !important;
    background-image: unset !important;
  }

  .vgt-wrap__footer .footer__navigation__page-info__current-entry{
    height: unset !important;
    padding: unset !important;
    font-size: 11px !important;
  }

  .vgt-input{
    height: unset !important;
    font-size: 11px !important;
  }

  .swal2-container{
    display: flex !important;
  }

  .email-actions-container .actions-container{
    width: 50%;
    display: flex;
    gap: 15px;
  }

  .email-actions-container .actions-container button{
    width: 50%;
    padding: 2%;
    gap: 10px;
    font-size: 1vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .email-actions-container .actions-container button img{
    width: 15px;
    height: auto;
  }

  .email-actions-container .actions-container button span{
    font-size: 15px;
    line-height: 1;
  }

  .email-actions-container{
    margin: 1% 0 3% 0;
  }
  
  @media only screen and (max-device-width: 767px){

    .collection-selection-container{
      flex-direction: column;
      align-items: flex-start;
    }

    .collection-selection-container .title {
      font-size: 3.5vw;
    }

    .email-actions-container .actions-container{
      width: 100%;
    }

    .email-actions-container .actions-container button{
      font-size: 3vw;
      width: unset;
    }

    .claimed-chart, .unclaimed-chart{
      width: 100%;
    }
    
  }
  
</style>>